import Vue from 'vue'
import App from './App.vue'
import MetaInfo from 'vue-meta-info'
import scroll from 'vue-seamless-scroll'
import { Popup } from 'vant';
import 'vant/lib/index.css';

Vue.use(Popup);
Vue.use(MetaInfo)
Vue.use(scroll)

if(window.location.href.indexOf('localhost:3001') === -1) {
  require('./utils/zhuge')
}
Vue.config.productionTip = false
for (const i in process.env) {
  const a = i.substr(13)
  window[a] = process.env[i]
}
new Vue({
  render: (h) => h(App),
  mounted: () => {
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
}).$mount('#app')
